export const TERMS = 'TERMS';
export const PRIVACY = 'PRIVACY';
export const COMMUNICATIONS = 'COMMUNICATIONS';
export const HARD_CREDIT = 'HARD_CREDIT';
export const ANTI_COERCION_ELECTION = 'ANTI_COERCION_ELECTION';
export const SOFT_CREDIT = 'SOFT_CREDIT';
export const TRUEWORK = 'TRUEWORK';
export const ACH_AUTOPAY = 'ACH_AUTOPAY';
export const MARKETING = 'MARKETING';
export const EMPINFO = 'EMPINFO';
export const SMS = 'SMS';
export const CREDIT_UNION_MEMBERSHIP = 'CREDIT_UNION_MEMBERSHIP';

export const REQUIRED_CONSENT_TYPES = [TERMS, PRIVACY, COMMUNICATIONS];

// opt in/out
export const OPT_IN = 'OPT_IN';
export const OPT_OUT = 'OPT_OUT';
